export const isRoiFlagEnabled = (): boolean => {
  try {
    // @ts-expect-error - TS2339 - Property 'senseStore' does not exist on type 'Window & typeof globalThis'.
    const state = window.senseStore.reduxStore.getState();
    return state.productFlags.releaseFlags.roiV2ApiEnabled;
  } catch (ex: any) {
    return false;
  }
};
